import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const IconXSCheckmark = ({
  color = colors.black,
  className,
  onClick,
}: IProps) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M1.5 4.33333L4.3 7L8.5 3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconXSCheckmark;
